<template>
    <article
        id="policy-details-insured-item"
        data-test-policy-insured-item
    >
        <h2>{{ value.LabelInsuredItemHeadline }}</h2>

        <field
            v-model="value.Address"
            name="Address-description"
        />

        <field
            v-model="value.ConstructionType"
            name="constructionType"
        />

        <field
            v-model="value.ConstructionSum"
            name="constructionSum-number"
        />

        <field
            v-if="value.ShowExistingBuildingCoverage"
            v-model="value.ExistingBuildingCoverage"
            name="existingBuildingCoverage"
        />

        <field
            v-model="value.ConstructionWorksDescription"
            name="constructionWorksDescription"
        />
    </article>
</template>

<script>
import Field from '../Field.vue';

export default {
    name: 'Construction',
    components: {
        Field
    },
    props: {
        value: {
            type: Object,
            default() {
                return null;
            }
        }
    }
};
</script>
